import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {Object} params
 * @param {string} params.className
 * @param {object} params.style
 * @param {(string|number)} params.value
 */
function SMCOption({
    className,
    style,
    value,
    disabled,
    children
}) {

    return (
        <option
            style={style}
            className={className}
            value={value}
            disabled={disabled}
        >
            {children}
        </option>
    );
}

SMCOption.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node
}

export default React.memo(SMCOption);